// @flow

import React, { useState } from 'react'
import RoundedLink from 'michelangelo/dist/Components/Buttons/RoundedLink'
import gradient from 'michelangelo/dist/Components/styles/gradient'
import color from 'michelangelo/dist/Components/styles/color'
import styled from 'styled-components'
import { Logo, Text } from './Sections'
import type { ReactComponentStyled } from 'styled-components'
import WebLinkLayout from './Layouts/WebLinkLayout'
import WebCaption from './Captions/WebCaption'
import WebTitle from './Titles/WebTitle'
import Column from 'michelangelo/dist/WebComponents/Layout/Column'

type WebContentProps = {
  title: string,
  logoUrl: string,
  caption: ?string,
  webUrl?: string,
  thumbnail?: ?string,
  fileUrl?: ?string,
  contentType: string,
  hashtags: string[]
}
const LinkContainer: ReactComponentStyled<{}> = styled.div`
  padding-top: 24px;
`
const ImageContainer: ReactComponentStyled<{}> = styled.div`
  width: ${(props) => props.verticalimage ? '100%' : '50%'};
  height: ${(props) => props.verticalimage ? '100vh' : 'auto'};
  padding: 16px;
  display: flex;
  justify-content: center;
  @media (max-width: 800px) {
    width: 100%;
    height: ${(props) => props.verticalimage ? '90vh' : 'auto'};
  }
`
const Image: ReactComponentStyled<{}> = styled.img`
  width: ${(props) => props.verticalimage ? 'auto' : '100%'};
  height: ${(props) => props.verticalimage ? '100%' : 'auto'};
`
const HeaderContainer: ReactComponentStyled<{}> = styled.div`
  height: 300px;
  width: 100%;
  background: ${color.moonlightGradient};
  justify-content: center;
  align-items: center;
  display: flex;
  padding: 0px 16px;
`
const LogoParent: ReactComponentStyled<{}> = styled.div`
  text-align: center;
`
/**
 * Web link and image content will use this layout to help display bigger images
 */
function WebContent ({ logoUrl, title, thumbnail, caption, webUrl, fileUrl, contentType, hashtags }: WebContentProps) {
  const [isVerticalImage, setIsVerticalImage] = useState(null)

  const handleCheckImageSize = (e) => {
    const img = e.currentTarget
    if (img.naturalWidth > img.naturalHeight) {
      setIsVerticalImage(false)
    } else if (img.naturalWidth < img.naturalHeight || img.naturalWidth === img.naturalHeight) {
      setIsVerticalImage(true)
    }
  }

  const getHeader = () => {
    if (thumbnail || fileUrl) {
      const img = <ImageContainer verticalimage={isVerticalImage}><Image verticalimage={isVerticalImage} src={thumbnail || fileUrl} onLoad={handleCheckImageSize} /></ImageContainer>
      return img
    }
    return <HeaderContainer><Text align='center' text={title} size='1' fontColor='white' /></HeaderContainer>
  }

  const getBodyTitle = () => {
    /**
     * We know that content type image should always have an image
     * If no images at all then show the gradient web title
     */
    if (contentType !== 'CONTENT_IMAGE' && !thumbnail) {
      return null
    }

    return <WebTitle title={title} />
  }

  const getCaption = () => {
    if (!caption) {
      return null
    }
    return <WebCaption isVerticalImage={isVerticalImage} usePadding={!logoUrl} caption={caption} hashtags={hashtags} />
  }

  const getLink = () => {
    return (
      <LinkContainer>
        <RoundedLink url={webUrl} target='_blank' theme={gradient.moonlightGradient}>Click here to view</RoundedLink>
      </LinkContainer>
    )
  }

  const getBody = () => {
    const title = getBodyTitle()
    const caption = getCaption()
    const link = webUrl ? getLink() : null
    return (
      <div>
        <Column classNames={['is-full']}><LogoParent><Logo src={logoUrl} /></LogoParent></Column>
        {title}
        {caption}
        {link}
      </div>
    )
  }
  const header = getHeader()
  const body = getBody()

  return (
    <WebLinkLayout isVerticalImage={isVerticalImage} header={header} body={body} usePadding={!logoUrl} />
  )
}

export default WebContent
